import { render, staticRenderFns } from "./New-Password.vue?vue&type=template&id=e976941e"
import script from "./New-Password.vue?vue&type=script&lang=js"
export * from "./New-Password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports